import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod';

import { nebankaOcpRoute } from '../NebankaOcpParentPage/route';

export const nebankaOcpAccountOrdersRoute = createRoute({
	path: '/orders',
	getParentRoute: () => nebankaOcpRoute,
	component: lazyRouteComponent(
		() => import('./NebankaOcpAccountOrdersPage'),
		'NebankaOcpAccountOrdersPage',
	),
	validateSearch: z.object({
		openedOrderId: z.string().optional(),
	}),
});
